import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Paper,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Preview = ({ formData }) => {
  return (
    <Box sx={{ width: '100%', padding: 2 }}>
      <Paper elevation={3} sx={{ padding: 2 }}>
        <Typography variant="h4" gutterBottom>
          Startup Formu Önizleme
        </Typography>

        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Genel Bilgiler</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: 'grid', gap: 2 }}>
              <Typography><strong>Startup Adı:</strong> {formData?.generalInfo?.startupName}</Typography>
              <Typography><strong>Kuruluş Tarihi:</strong> {formData?.generalInfo?.foundingDate}</Typography>
              <Typography><strong>Website:</strong> {formData?.generalInfo?.website}</Typography>
            </Box>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Takım Bilgileri</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: 'grid', gap: 2 }}>
              <Typography><strong>Takım Üye Sayısı:</strong> {formData?.teamInfo?.memberCount}</Typography>
              <Typography><strong>Kurucu Ortaklar:</strong> {formData?.teamInfo?.founders}</Typography>
            </Box>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Ürün/Hizmet Bilgileri</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: 'grid', gap: 2 }}>
              <Typography><strong>Ürün Açıklaması:</strong> {formData?.productInfo?.description}</Typography>
              <Typography><strong>Hedef Pazar:</strong> {formData?.productInfo?.targetMarket}</Typography>
            </Box>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Finansal Bilgiler</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: 'grid', gap: 2 }}>
              <Typography><strong>Mevcut Finansman:</strong> {formData?.financialInfo?.currentFunding}</Typography>
              <Typography><strong>Gelir Modeli:</strong> {formData?.financialInfo?.revenueModel}</Typography>
            </Box>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">İletişim Bilgileri</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: 'grid', gap: 2 }}>
              <Typography><strong>E-posta:</strong> {formData?.contactInfo?.email}</Typography>
              <Typography><strong>Telefon:</strong> {formData?.contactInfo?.phone}</Typography>
              <Typography><strong>Adres:</strong> {formData?.contactInfo?.address}</Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Paper>
    </Box>
  );
};

export default Preview;
